import { SetLanguageAction } from './types'
import { LANGUAGE_SET } from './actionTypes'

export const setLanguage = (language: string): SetLanguageAction => ({
  type: LANGUAGE_SET,
  language
})

export const fetchLanguage = (): SetLanguageAction => {
  const { language } = navigator
  return language && setLanguage(language)
}
